import { GridItem } from '@components/GridItem';
import { HorizontalGrid } from '@components/HorizontalGrid';
import { PrimaryButton } from '@components/Buttons/PrimaryButton';
import { SecondaryButton } from '@components/Buttons/SecondaryButton';
import { IForm } from '@hooks/useForm';
import { IStepper } from '@hooks/useStepper';
import { useValidation } from '@hooks/useValidation';
import { IValueState } from '@hooks/useValueState';
import { Box, makeStyles } from '@material-ui/core';
import ILinha from '@model/Linha';
import { IValidarNumeroResponse } from '@services/ContratoClienteService';
import { useThemeColor } from '@themes/Colors';
import { yup } from '@validations/Yup';
import React from 'react';
import clsx from 'clsx';

export type LinhaCommandProps = {
    linhaValueState: IValueState<IValidarNumeroResponse>
    form: IForm<Partial<ILinha>>
    stepper: IStepper
    onCancel?: VoidFunction
    onNext?: VoidFunction
}

export function LinhaCommand ({linhaValueState, form, stepper, onCancel, onNext}: LinhaCommandProps) {
    const cls = useStyles();
    const themeColor = useThemeColor();
    
    const handleCancel = React.useCallback(() => {
        linhaValueState.set({
            linha: null,
            contratoCliente: null
        });
        form.reset();
        if (onCancel !== undefined) {
            onCancel();
        }

    }, [form, linhaValueState, onCancel]);

    const searched = linhaValueState.value !== undefined && linhaValueState.value?.linha !== null;
    const linhaFound = !!linhaValueState.value?.linha;
    
    const validation = useValidation<ILinha>({
        contratoOperadoraId: yup.number().required(),
        linhaEmpresa: yup.string().booleanString(),
        vozIlimitada: yup.string().booleanString()
    });

    const next = React.useCallback(() => {
        stepper.next();
        if (onNext !== undefined) {
            onNext();
        }
    }, [onNext, stepper]);

    const handleNext = React.useCallback(() => {
        if (linhaFound) {
        console.log({
            form,
            values: form.getValues()
        })
            next();
        }
        else {
            const values = form.getInputValues();
            
            form.clearErrors();
            validation.validate(values)
                .then(() => {
                    form.saveValues();
                    next();
                })
                .catch(form.setErrorsFromYup);
        }
    }, [form, linhaFound, next, validation]);

    return (
        <Box className={cls.box}>
            <HorizontalGrid className={clsx(themeColor.component.commandPanel, cls.grid)}>
                <GridItem floatRight>
                    <HorizontalGrid spacing={1} verticalAlign="center">
                        <React.Fragment>
                            <GridItem>
                                <SecondaryButton onClick={handleCancel} disabled={!searched}>Cancelar</SecondaryButton>
                            </GridItem>

                            <GridItem>
                                <PrimaryButton onClick={handleNext} disabled={!searched}>Avançar</PrimaryButton>
                            </GridItem>
                        </React.Fragment>
                    </HorizontalGrid>
                </GridItem>
            </HorizontalGrid>
        </Box>
    )
}

const useStyles = makeStyles(theme => ({
    box: {
        marginTop: theme.spacing(1),
    },

    grid: {
        padding: `${theme.spacing(1)}px ${theme.spacing(4)}px`
    }
}));